export default __webpack_public_path__ + "static/media/Group 1285@2x.b756cbec.png";